export default __webpack_public_path__ + "static/default_recipe-194b06dbf62c36dfae3a54d353503891.png";